'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_scm_Map$() {
  this.kh = null;
  $j_java$002elang$002e$002dObject.$ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $j_java$002elang$002e$002dObject.$m_scm_HashMap$());
}
export { $c_scm_Map$ as $c_scm_Map$ };
$p = $c_scm_Map$.prototype = new $j_java$002elang$002e$002dObject.$h_sc_MapFactory$Delegate();
$p.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
export { $h_scm_Map$ as $h_scm_Map$ };
$h_scm_Map$.prototype = $p;
var $d_scm_Map$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_scm_Map$, "scala.collection.mutable.Map$", ({
  uF: 1,
  f2: 1,
  a: 1,
  bD: 1
}));
export { $d_scm_Map$ as $d_scm_Map$ };
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
export { $m_scm_Map$ as $m_scm_Map$ };
